function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("ellipse", {
  cx: 114.5,
  cy: 110,
  rx: 114.5,
  ry: 110,
  fill: "#EBB303"
});

function SvgEllipse(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 229,
    height: 220,
    fill: "none"
  }, props), _ref);
}

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjI5IiBoZWlnaHQ9IjIyMCIgdmlld0JveD0iMCAwIDIyOSAyMjAiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxlbGxpcHNlIGN4PSIxMTQuNSIgY3k9IjExMCIgcng9IjExNC41IiByeT0iMTEwIiBmaWxsPSIjRUJCMzAzIi8+Cjwvc3ZnPgo=";
export { SvgEllipse as ReactComponent };